import gql from 'graphql-tag';

export const CREATE_CLIENT_PROVISION_RULE = gql`
  mutation($input: CreateClientProvisionRuleInput!) {
    createClientProvisionRule(input: $input) {
      provisionRuleId
      name
      ruleEntityType
      ruleCondition
      items {
        itemId
        name
        category {
          categoryId
          name
        }
        sellingPrice {
          details {
            value
          }
        }
      }
      parentRule {
        provisionRuleId
        name
      }
      siteQuantities {
        site {
          id
          hq
        }
        quantity
      }
      defaultRule
    }
  }
`;

export const CREATE_TEMPLATE_PROVISION_RULE = gql`
  mutation($input: CreateProvisionRuleTemplateInput!) {
    createProvisionRuleTemplate(input: $input) {
      provisionRuleId
      name
      ruleEntityType
      ruleCondition
      items {
        itemId
        name
        sellingPrice {
          details {
            value
          }
        }
      }
      parentRule {
        provisionRuleId
        name
      }
      defaultRule
    }
  }
`;

export const UPDATE_CLIENT_PROVISION_RULE = gql`
  mutation($input: UpdateProvisionRuleInput!, $isClient: Boolean!) {
    updateProvisionRule(input: $input) {
      provisionRuleId
      name
      ruleEntityType
      ruleCondition
      items {
        itemId
        name
        description
        category {
          categoryId
          name
        }
        itemType
        sellingPrice {
          details {
            value
          }
        }
      }
      parentRule {
        provisionRuleId
        name
      }
      siteQuantities @include(if: $isClient) {
        site {
          id
        }
        quantity
      }
      defaultRule
    }
  }
`;

export const DELETE_CLIENT_PROVISION_RULE = gql`
  mutation($input: ProvisionRuleIdentifierInput!) {
    deleteProvisionRule(input: $input)
  }
`;

export const HARD_RESET_CONTRACT = gql`
  mutation($input: ClientIdentifierInput!) {
    hardResetClientContracts(input: $input)
  }
`;

export const UPDATE_BILLABLE_CONTRACT_PRICES = gql`
  mutation($input: UpdateBillableContractPricesInput!) {
    updateBillableContractPrices(input: $input)
  }
`;
